import React from 'react';

const BoardList = React.lazy(() => import("@/pages/board/BoardList"));
const BoardDetail = React.lazy(() => import("@/pages/board/BoardDetail"));
const BoardInsert = React.lazy(() => import("@/pages/board/BoardInsert"));
const Chat = React.lazy(() => import("@/pages/chat/Chat"));
const Gpt = React.lazy(() => import("@/pages/chat/Gpt"));
const LuckPage = React.lazy(() => import("@/pages/luck/LuckPage"));
const ChatList = React.lazy(() => import("@/pages/chat/ChatList"));
const HealthyPage = React.lazy(() => import("@/pages/healthy/HealthyPage"));
const FindGamePage = React.lazy(() => import("@/pages/findGame/FindGamePage"));
const EventPage = React.lazy(() => import("@/pages/event/EventPage"));

export const Routes = [
    { path: "/boardList", element: <BoardList />, requiredRoles: ['user','admin','vvip','svip'] },
    { path: "/boardDetail", element: <BoardDetail />, requiredRoles: ['user','admin','vvip','svip'] },
    { path: "/boardInsert", element: <BoardInsert />, requiredRoles: ['user','admin','vvip','svip'] },
    { path: "/chat", element: <Chat />, requiredRoles: ['vvip','svip'] },
    { path: "/ChatList", element: <ChatList />, requiredRoles: ['vvip','svip'] },
    { path: "/gpt", element: <Gpt />, requiredRoles: ['user','admin','vvip','svip'] },
    { path: "/luck", element: <LuckPage />, requiredRoles: ['user','admin','vvip','svip'] },
    { path: "/healthy", element: <HealthyPage />, requiredRoles: ['user','admin','vvip','svip'] },
    { path: "/findGame", element: <FindGamePage />, requiredRoles: ['user','admin','vvip','svip'] },
    { path: "/event", element: <EventPage />, requiredRoles: ['svip','vvip'] },
];
